require('../changeData.scss');
//@vendors
const React = require('react');
const { connect } = require('react-redux');
//@components
const { ItemAddressContent } = require('components/changeDataAC/address/itemAddressContent');

export class ItemAddress extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showComponent: false,
        };
    }

    handleShowAddressBlock = () => {
        this.props.changeStyles('telefono');
        this.props.changeStyles('email');
        this.setState({
            showComponent: true,
        });
    };

    handleToggle = () => {
        this.props.changeStyles('telefono');
        this.props.changeStyles('email');
        this.setState({
            showComponent: !this.state.showComponent,
        });
    };

    render() {
        const original = (
            <li className="item">
                <p className="item__edit">
                    <a
                        href="#"
                        className={this.props.estilo}
                        onClick={event => {
                            event.preventDefault();
                            this.handleShowAddressBlock();
                        }}
                    >
                        <i className={this.props.estilo + ' icons icons--icon-edit-2'}></i>
                    </a>
                </p>
                <div className="item-info">
                    <p className="item__title">{this.props.title}</p>
                    <p className="item__content">{this.props.content}</p>
                </div>
            </li>
        );
        return (
            <div>
                {this.state.showComponent ? (
                    <ItemAddressContent onCancel={this.handleToggle} onSuccess={this.handleToggle} />
                ) : (
                    original
                )}
            </div>
        );
    }
}

module.exports.ItemAddress = connect(state => ({
    userProfile: state.userProfile,
    userProfileForm: state.userProfileForm,
}))(ItemAddress);
